module.exports = __webpack_public_path__ + "img/whatIsUrbanMining.4b4618b.webp";